import type {
    PanelReplacementCancelSelectionHandler,
    PanelReplacementDirection,
    PanelReplacementDirectionHandler
} from 'app/modules/wallforming/components/scenes/tools/quick-panel-replacement/types/quickPanelReplacementTypes';

export type { PanelReplacementDirection } from 'app/modules/wallforming/components/scenes/tools/quick-panel-replacement/types/quickPanelReplacementTypes';

let directionHandler: PanelReplacementDirectionHandler | undefined;
let cancelSelectionHandler: PanelReplacementCancelSelectionHandler | undefined;

export function registerPanelQuickReplacementDirectionHandler(handler: PanelReplacementDirectionHandler): () => void {
    directionHandler = handler;
    return () => {
        if (directionHandler === handler) {
            directionHandler = undefined;
        }
    };
}

export function dispatchPanelQuickReplacementDirection(
    direction: PanelReplacementDirection,
    shrink: boolean
): boolean {
    return directionHandler?.(direction, shrink) ?? false;
}

export function registerPanelQuickReplacementCancelSelectionHandler(
    handler: PanelReplacementCancelSelectionHandler
): () => void {
    cancelSelectionHandler = handler;
    return () => {
        if (cancelSelectionHandler === handler) {
            cancelSelectionHandler = undefined;
        }
    };
}

export function cancelPanelQuickReplacementSelection(): boolean {
    return cancelSelectionHandler?.() ?? false;
}
